<template>

    <app-fail-message>404 Ja so a Seitn gibt´s do ned...</app-fail-message>

</template>

<script>
import FailMessage from '../components/FailMessage'

export default {

    components: {
        appFailMessage: FailMessage
    }

}
</script>
